import React from 'react';
import IconAmenityMobile from '@spothero/icons/amenity-mobile';
import IconCheckCircle from '@spothero/icons/check-circle';
import IconSearch from '@spothero/icons/search';
import Card from 'common/card/Card';

const CONTENT = [
    {
        title: 'Look',
        icon: IconSearch,
        description:
            'Find and compare pricing on convenient parking spots near your destination',
    },
    {
        title: 'Book',
        icon: IconCheckCircle,
        description:
            'Prepay for your spot and get a parking pass instantly via text, email, or the app',
    },
    {
        title: 'Park',
        icon: IconAmenityMobile,
        description:
            "Scan or show your mobile parking pass when you arrive, and you're all set!",
    },
];

const LookBookPark = () => (
    <Card className="LookBookPark">
        <ul className="LookBookPark-list">
            {CONTENT.map(({description, icon: Icon, title}) => (
                <li className="LookBookPark-item" key={title}>
                    <div className="LookBookPark-icon">
                        <Icon />
                    </div>
                    <div className="LookBookPark-content">
                        <h1 className="LookBookPark-title">{title}</h1>
                        <p className="LookBookPark-description">
                            {description}
                        </p>
                    </div>
                </li>
            ))}
        </ul>
    </Card>
);

export default LookBookPark;
